import { useMemo } from 'react'

import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

import { useAreaWeatherForecast } from '~/hooks/weather/useAreaWeatherForecast'
import { toProtoDate } from '~/models/dateTime'
import {
  type AreaWeatherIcons,
  buildAreaWeatherIcons,
} from '~/models/weather/forecastIcons'

export type UseAreaWeatherIconsParams = {
  areaCode: AreaCode
  /**
   * 対象日 (単日)。気象 gRPC へは `from = to = displayDate` で渡す。応答は
   * 対象日 00:00 〜 翌日 00:00 の手前までの点だけで、翌日 0 時の点は含まれない。
   */
  displayDate: Date
  enabled?: boolean
}

/**
 * エリア + 対象日の予報を単体 RPC (WeatherForecastService.GetAreaWeatherForecast)
 * で取り、天気アイコン帯・予想気温ラベル・予想気温の数値系列に組み立てる
 * (組み立ては `buildAreaWeatherIcons`。同時同量 一覧の batch 取得と共有)。
 */
export function useAreaWeatherIcons(
  params: UseAreaWeatherIconsParams,
): AreaWeatherIcons {
  const targetDate = toProtoDate(params.displayDate)
  const { data } = useAreaWeatherForecast({
    areaCode: params.areaCode,
    targetDateFrom: targetDate,
    targetDateTo: targetDate,
    enabled: params.enabled,
  })

  return useMemo(
    () => buildAreaWeatherIcons(data?.forecast, targetDate),
    [data, targetDate],
  )
}
